import React, {ReactNode} from 'react';
import {StyleSheet, View} from 'react-native';

import Text from '../../../components/ui-controls/Text';

type SectionTitleProps = {
  children: ReactNode;
  style?: React.CSSProperties;
};

const SectionTitle = ({children, style}: SectionTitleProps) => (
  <View style={[styles.webDesktopSectionTitleView, style]}>
    <Text variant="heading1">{children}</Text>
  </View>
);

export default SectionTitle;

const styles = StyleSheet.create({
  webDesktopSectionTitleView: {
    alignItems: 'center',
    marginTop: 8,
    marginBottom: 16,
    width: '100%',
  },
});
